import axios from 'axios';
import type { HeadersDefaults } from 'axios';
import { API_URL } from '@/configs';
import AuthService from '@/services/auth.service';

const http = axios.create({
  baseURL: API_URL,
});

http.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // A request that asks for a blob — the PDF export does — gets its ERROR body
    // as a Blob as well, not just the 2xx body. Reading `.error` straight off it
    // is always undefined, so a revoked session used to slip past the check below
    // and surface as a generic failure while the user stayed signed in to a dead
    // token. Unwrap it first.
    let data = error?.response?.data;

    if (typeof Blob !== 'undefined' && data instanceof Blob) {
      try {
        data = JSON.parse(await data.text());
      } catch {
        data = undefined;
      }
    }

    if (error?.response?.status === 401 && data?.error === 'revoked token') {
      AuthService.clearCache();
      return error;
    }

    return Promise.reject(data || 'Unknown Error');
  },
);

const setHTTPHeader = (header: HeadersDefaults['common']) => {
  http.defaults.headers.common = { ...http.defaults.headers.common, ...header };
};

export { http, setHTTPHeader };
